<template>
  <v-container
    class="paddingLeft"
    fluid
    style="padding-top: 80px; padding-left: 130px; min-height: 800px"
  >
    <v-flex xs-12 class="row pt-5 mr-2">
      <v-flex xs12 lg7 class="">
        <v-flex class="title font-weight-regular pb-2">
          {{ carShop.length }} Producto en su cesta
        </v-flex>
        <v-flex xs12 v-for="(item, index) in carShop" :key="index" class="mb-3">
          <v-hover>
            <v-card
              color=""
              max-height="150"
              style="padding: 2px; border-radius: 6px"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 8 : 2}`"
              class="mx-auto"
            >
              <v-layout>
                <v-flex xs4 lg4 class="hide" style="border-radius: 6px">
                  <v-img
                    :src="item.mounted_courses.courses.data.imageUrl"
                    max-height="140"
                    contain
                    style="border-radius: 10px; margin-top: 3px"
                  ></v-img>
                </v-flex>
                <v-flex xs10 lg8>
                  <v-card-title primary-title>
                    <div>
                      <div class="title">
                        {{ item.mounted_courses.courses.name }}
                      </div>
                      <div class="hide">
                        {{
                          item.mounted_courses.courses.description.substring(
                            0,
                            80
                          ) + ".."
                        }}
                      </div>
                      <div class="deep-purple--text title pt-2">
                        Valor: {{ item.mounted_courses.data.price }}$
                      </div>
                    </div>
                  </v-card-title>
                </v-flex>
                <v-flex xs1>
                  <v-card-title primary-title>
                    <div>
                      <div class="headline floatRight">
                        <i
                          class="fas fa-trash-alt"
                          style="
                            font-size: 2rem;
                            color: #5e72e4;
                            cursor: pointer;
                          "
                          @click.prevent="deleteItem(item.id)"
                        ></i>
                      </div>
                    </div>
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-card>
          </v-hover>
        </v-flex>
      </v-flex>
      <v-flex xs12 lg3 offset-lg1>
        <p v-if="!progress" class="text-center">
          <v-progress-circular
            indeterminate
            color="purple"
          ></v-progress-circular>
        </p>
        <p
          class="display-2 font-weight-light pt-4 pt-sm-4 text-center pt-sm-5"
          v-else
        >
          {{ total_price.toFixed(2) + " $" }}
        </p>

        <v-btn
          depressed
          large
          disabled
          class="light-blue accent-4 pt-4 pb-5"
          style="width: 90%; color: white"
          v-if="!progress"
          >PAGAR</v-btn
        >
        <v-btn
          depressed
          large
          @click.prevent="paymentezCheckout()"
          class="light-blue accent-4 pt-4 pb-5"
          style="width: 100%; color: white"
          v-else
          >PAGAR</v-btn
        >

        <v-divider light style="width: 100%"></v-divider>

        <p>Pague de forma segura con sus tarjetas Visa y Master Card</p>
        <img
          style="width: 30%"
          src="data:image/png;base64,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"
        />
      </v-flex>
    </v-flex>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import toastr from "toastr";
export default {
  name: "paymentIni",
  components: {},
  created() {
    this.getShoppingCar();
  },
  data() {
    return {
      progress: false,
      popo: "",
    };
  },
  computed: {
    ...mapState,
    // ...mapGetters(["carShop"]),
    ...mapGetters({
      carShop: "shopingCart/getCart",
      total_price: "shopingCart/price_total"
    }),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },
  methods: {
    getShoppingCar: function () {
      this.$store.dispatch("shopingCart/getCart").then((data) => {
          this.progress = true;
      });
    },

    deleteItem: function (id) {
      var url = "/api/v1/deleteShoppingCar";
      var token = (axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("a_t"));
      axios
        .post(url, {
          headers: {
            token,
          },
          id: id,
          user_id: this.userId.id,
        })
        .then((response) => {
          // this.$store.commit("car", response.data);
          toastr.success("Item Eliminado");
          this.getShoppingCar();
        });
    },

    paymentezCheckout: function () {
      const self = this;
      const email = this.userId.email;
      const user_id = this.userId.id;
      const total_price = this.total_price;
      const order_vat = parseFloat((total_price / 1.12) * 0.12).toFixed(2);
      const taxable_amount = parseFloat(total_price / 1.12).toFixed(2);
      var paymentezCheckout = new PaymentezCheckout.modal({
        client_app_code: process.env.VUE_APP_PAYMENTEZ_CLIENT, // Client Credentials Provied by Paymentez
        client_app_key: process.env.VUE_APP_PAYMENTEZ_SECRET, // Client Credentials Provied by Paymentez
        locale: "es", // User's preferred language (es, en, pt). English will be used by default.
        env_mode: process.env.VUE_APP_ENVIROMENT, // `prod`, `stg` to change environment. Default is `stg`
        onOpen: function () {
          console.log("modal open");
        },
        onClose: function () {
          console.log("modal closed");
        },
        onResponse: function (response) {
          // The callback to invoke when the Checkout process is completed

          var transaction = response.transaction.status;
          console.log(response);
          if (transaction === "success") {
            self.progress = false;

            var url = "/api/v1/insertUserCourses";
            var token = (axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorage.getItem("a_t"));
            axios
              .post(url, {
                headers: {
                  token,
                },
                user_id: user_id,
                transactional_id: response.transaction.id,
                authorization_code: response.transaction.authorization_code,
                payment_method_id: "1",
                note: response.transaction.message,
                status: response.transaction.status,
                data: response,
                amount: response.transaction.amount,
              })
              .then((response) => {
                self.getShoppingCar()
              });

            setTimeout(function () {
              toastr.success("Compra exitosa");
              self.$router.push("/home/payment/success");
            }, 5000);
          } else if (transaction === "pending") {
            self.progress = false;

            var url = "/api/v1/insertUserCoursesPending";
            var token = (axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorage.getItem("a_t"));
            axios
              .post(url, {
                headers: {
                  token,
                },
                user_id: user_id,
                transactional_id: response.transaction.id,
                authorization_code: response.transaction.authorization_code,
                payment_method_id: "1",
                note: response.transaction.message,
                status: response.transaction.status,
                data: response,
                amount: response.transaction.amount,
                order_data: response,
              })
              .then((response) => {
                 self.getShoppingCar()
              });

            setTimeout(function () {
              toastr.info("Compra pendiente de aprobación");
              self.$router.push("/home/payment/pending");
            }, 5000);
          } else if (transaction === "failure") {
            self.progress = false;

            var url = "/api/v1/insertUserCoursesFailure";
            var token = (axios.defaults.headers.common["Authorization"] =
              "Bearer " + localStorage.getItem("a_t"));
            axios
              .post(url, {
                headers: {
                  token,
                },
                user_id: user_id,
                transactional_id: response.transaction.id,
                authorization_code: response.transaction.authorization_code,
                payment_method_id: "1",
                note: response.transaction.message,
                status: response.transaction.status,
                data: response,
                amount: response.transaction.amount,
                order_data: response,
              })
              .then((response) => {});

            setTimeout(function () {
              toastr.error("Compra rechazada");
              toastr.options = {
                positionClass: "toast-top-left",
              };
              self.$router.push("/home/payment/failure");
            }, 5000);
          }
          /*
                          In Case of an error, this will be the response.
                          response = {
                            "error": {
                              "type": "Server Error",
                              "help": "Try Again Later",
                              "description": "Sorry, there was a problem loading Checkout."
                            }
                          }

                          When the User completes all the Flow in the Checkout, this will be the response.
                          response = {
                             "transaction": {
                                "status": "success", // success, failure or pending
                                "payment_date": "2017-09-26T21:03:04",
                                "amount": 99.0,
                                "authorization_code": "148177",
                                "installments": 1,
                                "dev_reference": "referencia",
                                "message": "Operation Successful",
                                "carrier_code": "6",
                                "id": "CI-490", // transaction_id
                                "status_detail": 3 // for the status detail please refer to: https://paymentez.github.io/api-doc/#status-details
                             },
                             "card": {
                                "bin": "453254",
                                "status": "valid",
                                "token": "",
                                "expiry_year": "2020",
                                "expiry_month": "9",
                                "transaction_reference": "CI-490",
                                "type": "vi",
                                "number": "8311"
                            }
                         }

                        */
          console.log("modal response");
          /*document.getElementById('response').innerHTML = JSON.stringify(response);*/
        },
      });

      /*var btnOpenCheckout = document.querySelector('.js-paymentez-checkout');*/
      /*      btnOpenCheckout.addEventListener('click', function(){*/
      // Open Checkout with further options:
      paymentezCheckout.open({
        user_id: String(user_id),
        user_email: email, //optional
        user_phone: "", //optional
        order_description: "Cursos Cambiando Salud",
        order_amount: total_price,
        order_vat: Number(order_vat),
        order_reference: "#234323411",
        //order_installments_type: 2, // optional: For Colombia an Brazil to show installments should be 0, For Ecuador the valid values are: https://paymentez.github.io/api-doc/#payment-methods-cards-debit-with-token-installments-type
        order_taxable_amount: Number(taxable_amount), // optional: Only available for Datafast (Equador). The taxable amount, if it is zero, it is calculated on the total. Format: Decimal with two fraction digits.
        order_tax_percentage: 12, // optional: Only available for Datafast (Equador). The tax percentage to be applied to this order.
      });
      /*});*/

      // Close Checkout on page navigation:
      window.addEventListener("popstate", function () {
        paymentezCheckout.close();
      });
    },
  },
};
</script>
<style>
@media screen and (max-width: 900px) {
  .hide {
    display: none !important;
  }
}

@media screen and (max-width: 768px) {
  .paddingLeft {
    padding-left: 30px !important;
  }
}
@media screen and (max-width: 1024px) {
  .paddingLeft {
    padding-left: 30px !important;
  }
  .floatRight {
    padding-top: 13px;
  }
}
</style>